import { helpers } from "../../common/lib";
import getInitialState from "../get-initial-state";
import { actionTypes } from "./actions";

export default function (state = getInitialState.list(), action) {
    switch (action.type) {
        case actionTypes.AUDIT_IMAGE_ITEM_SET: {
            const { auditImage } = action.payload;
            return { ...state, item: auditImage };
        }
        case actionTypes.AUDIT_IMAGES_SET: {
            const { auditImages } = action.payload;
            return helpers.getListReducer(state, auditImages);
        }

        default: {
            return state;
        }
    }
}
